import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@shared/components/error-dialog/error-dialog.component';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const getMessage = (error: HttpErrorResponse) => {
  if ((error.status === 400 || error.status === 500) && error.url?.includes('/profile/register')) {
    if (error.error?.message) {
      return error.error.message;
    }
  }

  return 'Something went wrong. Please try again later';
};

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _errorDialog = inject(MatDialog);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error.code === 'InvalidOtpError') {
        return throwError(() => error);
      }

      _errorDialog.open(ErrorDialogComponent, {
        data: { errorMessage: getMessage(error) },
      });

      return throwError(() => error);
    })
  );
};
